import React from "react";
import {ActionRow, ActionRowDropdownButton, DropdownItem, DropdownItemGroup, DropdownItemGroups, Icon} from "peggirkit";
import {BoltIcon} from "@heroicons/react/24/outline";
import {FormattedMessage} from "react-intl";
import SetStatusButton from "./SetStatusButton";
import {JobApplicationDetails} from "@/data/entities/jobApplication";
import {UpdateJobApplicationControlProps} from "../../JobApplicationEditor";

type Props = UpdateJobApplicationControlProps & {
    loading: boolean,
    jobApplication: JobApplicationDetails | undefined,

};

const JobApplicationActions = ({jobApplication, ...updateFormsProps}: Props) => {

    return (
        <ActionRow>
            {SetStatusButton({
                ...updateFormsProps,
                initialLoading: jobApplication === undefined,
            })}

            <ActionRowDropdownButton
                disabled={updateFormsProps.loading || jobApplication === undefined}
                color={"secondary"}
                iconBefore={<Icon icon={BoltIcon}/>}
                items={
                    <DropdownItemGroups>
                        <DropdownItemGroup>
                            <DropdownItem
                                buttonAction={{as: "groupLabel", actionProps: {}}}
                            >
                                <FormattedMessage id={"noActions"}/>
                            </DropdownItem>
                        </DropdownItemGroup>
                    </DropdownItemGroups>
                }
            >
                <FormattedMessage id={"actions"}/>
            </ActionRowDropdownButton>
        </ActionRow>
    );
};

export default JobApplicationActions;